
import barba from '@barba/core';


export default class {
    constructor() {
        
        const _ua = this._ua(window.navigator.userAgent.toLowerCase())
        // barba.hooks.once(() => {
        //     this.container = document.querySelector("[data-moment-scroll]")

        // });

        // barba.hooks.leave(() => {
        //     window.removeEventListener('scroll', this.movieScroll.bind(this))
        // })

        // barba.hooks.after(() => {
        //     this.container = document.querySelector("[data-moment-scroll]")
            
        // });

        if(!_ua.Mobile&&!_ua.Tablet){
            if(!navigator.userAgent.match(/Trident\/7\./)) {
                barba.hooks.once(() => {
                    this.container = document.querySelector("[data-moment-scroll]")
                    this.scrollY = 0
                    this.translateY = 0
                    this.speed = 0.3
                    this.rafId = null
                    this.isActive = false
                
                    this.scrollHandler = this.scroll.bind(this)
                    this.resizeHandler = this.resize.bind(this)
                    this.run()
                });
                barba.hooks.leave(() => {
                    this.destroy()
                })
                barba.hooks.after(() => {
                    this.container = document.querySelector("[data-moment-scroll]")
                    this.scrollY = 0
                    this.translateY = 0 
                    this.rafId = null
                    this.isActive = false
                    setTimeout(() => {
                        this.run()
                    }, 300);
                });
            }
        }
    }
  
    run() {
        if (this.isActive) {
            return
        }
    
        this.isActive = true
    
        this.on()
        this.setStyles()
    }
  
    destroy() {
        if (!this.isActive) {
            return
        }
    
        this.isActive = false
    
        this.off()
        this.clearStyles()
    
        if (this.rafId) {
            cancelAnimationFrame(this.rafId)
        }
    
        this.rafId = null
    }
  
    resize() {
        document.body.style.height = `${this.container.clientHeight}px`
    }
  
    scroll() {
        this.scrollY = window.scrollY || window.pageYOffset
        
        
        if (!this.rafId) {
            this.container.style.willChange = 'transform'
            this.rafId = requestAnimationFrame(() => this.render())
        }
    }

    // movieScroll() {
    //     if(this.movie){
    //         const scrollY = window.scrollY || window.pageYOffset
            
    //         if(scrollY < 300){
    //             this.movie.style.opacity = 0
    //         }else if(scrollY > this.container.clientHeight - window.outerHeight * 1.5 ){
    //             this.movie.style.opacity = 0
    //         }else{
    //             this.movie.style.opacity = 1
    //         }   
    //     }
    // }
  
    on() {
        this.resize()
        this.scroll()
        window.addEventListener('scroll', this.scrollHandler, { passive: true })
        window.addEventListener('resize', this.resizeHandler)
        window.addEventListener('load', this.resizeHandler)
    }
  
    off() {
        window.removeEventListener('scroll', this.scrollHandler)
        window.removeEventListener('resize', this.resizeHandler)
        window.removeEventListener('load', this.resizeHandler)
    }
  
    setStyles() {
        this.container.style.position = 'fixed'
        this.container.style.width = '100%'
        this.container.style.top = 0
        this.container.style.left = 0
    }
  
    clearStyles() {
        document.body.style.height = ''
        this.container.style.position = ''
        this.container.style.width = ''
        this.container.style.top = ''
        this.container.style.left = ''
        this.container.style.transform = ''
        this.container.style.willChange = ''
    }
  
    render() {
        const nextY = this.translateY + (this.scrollY - this.translateY) * this.speed    
        const isNear = Math.abs(this.scrollY - nextY) <= 0.1
    
        this.translateY = isNear ? this.scrollY : nextY
    
        const roundedY = Math.round(this.translateY * 100) / 100
    
        this.container.style.transform = `translate3d(0, -${roundedY}px, 0)`
    
        if (isNear) {
            this.rafId = null
            this.container.style.willChange = ''
        } else {
            this.rafId = requestAnimationFrame(() => this.render())
        }
    }
    _ua (u){
        return {
            Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
            || u.indexOf("ipad") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
            || u.indexOf("kindle") != -1
            || u.indexOf("silk") != -1
            || u.indexOf("playbook") != -1,
            Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            || u.indexOf("iphone") != -1
            || u.indexOf("ipod") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
            || u.indexOf("blackberry") != -1
        }
    }
}